import { giphyLightGrey } from '@giphy/js-brand'
import { IGif, IProfileUser } from '@giphy/js-types'
import React from 'react'
import styled from 'styled-components'
import Avatar from '../avatar'
import VerifiedLogo from '../verified-badge'

export const footerHeight = 42

const AttributionContainer = styled.div`
    flex: 1;
    height: ${footerHeight}px;
    display: flex;
    font-weight: bold;
    img {
        width: ${footerHeight}px;
        height: ${footerHeight}px;
        margin-right: 8px;
    }
`

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    width: 0;
`

const DisplayName = styled.div`
    font-size: 16px;
    user-select: none;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`

const Username = styled.a`
    font-size: 14px;
    color: ${giphyLightGrey};
    display: flex;
    align-items: center;
    text-decoration: none;
    :hover {
        color: white;
    }
`
const Attribution = ({ gif }: { gif: IGif }) => {
    const user = gif.user as IProfileUser
    if (!user || !user.profile_url) {
        return null
    }
    const { is_verified: showVerifiedBadge, username, display_name: displayName, profile_url: channel } = user
    return (
        <AttributionContainer>
            <Avatar user={user} />
            <TextContainer>
                <DisplayName>{displayName || username}</DisplayName>
                <Username href={channel} target="_blank" rel="noopener noreferrer">
                    @{username}&nbsp;
                    {showVerifiedBadge && <VerifiedLogo size={14} />}
                </Username>
            </TextContainer>
        </AttributionContainer>
    )
}

export default Attribution
